/**
 * Villy Shop home: video pause control, the hero that opens as you scroll, and the transparent-header handshake.
 * Depends on vs-core.js. Safe to load twice.
 */
(function () {
  'use strict';
  if (window.__vsHomeLoaded) return;
  window.__vsHomeLoaded = true;

  var doc = document;
  var VS = function () { return window.VillyShop || {}; };
  var reduce = function () { return !!(VS().reduceMotion && VS().reduceMotion.matches); };
  var PAUSE = '<svg class="vs-icon" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 6v12M15 6v12"/></svg>';
  var PLAY = '<svg class="vs-icon" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M8 5.5v13l10-6.5z"/></svg>';

  /* ---------- video: pause / play, paused at once for reduced motion ---------- */
  function initVideo(scope) {
    var buttons = (scope || doc).querySelectorAll('[data-vs-pause]:not([data-vs-ready])');
    Array.prototype.forEach.call(buttons, function (btn) {
      btn.setAttribute('data-vs-ready', '1');
      var holder = btn.parentElement;
      var video = holder && holder.querySelector('video');
      if (!video) { btn.hidden = true; return; }
      function paint() {
        var paused = video.paused;
        btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
        btn.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');
        btn.innerHTML = paused ? PLAY : PAUSE;
      }
      btn.addEventListener('click', function () {
        if (video.paused) { var p = video.play(); if (p && p.catch) p.catch(function () {}); } else video.pause();
      });
      video.addEventListener('play', paint);
      video.addEventListener('pause', paint);
      if (reduce()) video.pause();
      paint();
    });
  }

  /* ---------- hero story layout: scroll progress 0..1 written on the section ---------- */
  function initStory(scope) {
    var heroes = (scope || doc).querySelectorAll('[data-vs-hero="story"]:not([data-vs-ready])');
    Array.prototype.forEach.call(heroes, function (hero) {
      hero.setAttribute('data-vs-ready', '1');
      var ticking = false;
      function update() {
        ticking = false;
        if (reduce() || window.innerWidth < 750) { hero.style.setProperty('--p', '1'); return; }
        var rect = hero.getBoundingClientRect();
        var run = Math.max(1, rect.height - window.innerHeight);
        var p = Math.max(0, Math.min(1, -rect.top / run));
        // the first screen shows the three columns; the story starts as soon as the page moves
        hero.style.setProperty('--p', p.toFixed(3));
      }
      function onScroll() { if (!ticking) { ticking = true; window.requestAnimationFrame(update); } }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      update();
    });
  }

  function init(scope) { initVideo(scope); initStory(scope); }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  doc.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
